import { recordSystemMessage } from "@/lib/system-messages";

export type ToastKind = "error" | "success";
/** Optional buttons rendered inside a system message (callbacks cannot be stored). */
export type ToastAction = { label: string; onClick: () => void; primary?: boolean };

export function showToast(message: string, kind: ToastKind = "success", actions?: ToastAction[]) {
  if (typeof window === "undefined" || !message) return;
  // Screen-top messages are also kept in the notification tray.
  recordSystemMessage(message, kind);
  window.dispatchEvent(new CustomEvent("tairoh-toast", { detail: { message, kind, actions } }));
}

/** A channel / attendance notification shown briefly at the top right. */
export function showNotificationToast(payload: { id: string | number; title: string; body?: string; url?: string }) {
  if (typeof window === "undefined" || !payload?.title) return;
  window.dispatchEvent(new CustomEvent("tairoh-notification-toast", {
    detail: { id: String(payload.id), title: payload.title, body: payload.body ?? "", url: payload.url ?? "/app/all/home" },
  }));
}
